<template lang="pug">
    div
      #fpsmeter
      div(style='padding-left: 6rem')
        p Enter [{{enterBatchLength}}] / Exit [{{exitBatchLength}}] / Update [{{updateBatchLength}}] / Run [{{runBatchLength}}] / Wait [{{waitBatchLength}}] Errors [{{errorsLength}}]
        p (Time) Enter [{{lastEnterDuration}}] Update [{{lastUpdateDuration}}] Exit [{{lastExitDuration}}] / Wait [{{lastWaitDuration}}]
        p (Count) Enter [{{lastEnterCount}}] Update [{{lastUpdateCount}}] Exit [{{lastExitCount}}] / Wait [{{lastWaitCount}}]

</template>
<script>
export default {
  props:{
    renderTools:{
      type: Object,
      required: true
    }
  },
  data() {
    return {
      runBatchLength:0,
      waitBatchLength:0,
      exitBatchLength:0,
      updateBatchLength:0,
      enterBatchLength:0,

      lastEnterDuration:0,
      lastUpdateDuration:0,
      lastExitDuration:0,
      lastRunDuration:0,
      lastWaitDuration:0,

      lastEnterCount:0,
      lastUpdateCount:0,
      lastExitCount:0,
      lastRunCount:0,
      lastWaitCount:0,

      errorsLength:0
    }
  },
  mounted() {
    this.interval = setInterval(this.captureCounters.bind(this), 200);
    const fpsHolder = this.$el.querySelectorAll('#fpsmeter')[0];
    this.meter = new FPSMeter(fpsHolder, {
      graph:1
    });
    this.renderTools.onRenderStart = () => {
      this.meter.tickStart();
    }
    this.renderTools.onRenderEnd = () => {
      this.meter.tick();
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
    this.meter.destroy();
  },
  methods:{
    captureCounters() {
      this.runBatchLength = this.renderTools.runBatch.length;
      this.waitBatchLength = this.renderTools.waitBatch.length;
      this.exitBatchLength = this.renderTools.exitBatch.length; 
      this.updateBatchLength = this.renderTools.updateBatch.length;
      this.enterBatchLength = this.renderTools.enterBatch.length;

      this.errorsLength = this.renderTools.errors.length;

      const frames = Math.max(this.renderTools.stats.frames,1);
      this.lastEnterDuration = (this.renderTools.stats.lastEnterDuration / frames).toFixed(2);
      this.lastUpdateDuration = (this.renderTools.stats.lastUpdateDuration / frames).toFixed(2);
      this.lastExitDuration = (this.renderTools.stats.lastExitDuration / frames).toFixed(2);
      this.lastRunDuration = (this.renderTools.stats.lastRunDuration / frames).toFixed(2);
      this.lastWaitDuration = (this.renderTools.stats.lastWaitDuration / frames).toFixed(2);

      this.lastEnterCount = (this.renderTools.stats.lastEnterCount / frames).toFixed(0);
      this.lastUpdateCount = (this.renderTools.stats.lastUpdateCount / frames).toFixed(0);
      this.lastExitCount = (this.renderTools.stats.lastExitCount / frames).toFixed(0);
      this.lastRunCount = (this.renderTools.stats.lastRunCount / frames).toFixed(0);
      this.lastWaitCount = (this.renderTools.stats.lastWaitCount / frames).toFixed(0);

      this.renderTools.clearStats();

    },
  }
}
</script>
